{"id":"MiniBanners","prefabs":{"default":{"children":[{"component":"MiniBanners","options":"options:*"}]}}}